<template >
    <div style="display: inline-block">
        <slot></slot>
    </div>
</template>

<script>
export default {};
</script>
